import { FaPlus } from "react-icons/fa";
import { Button } from "./Buttons";

const PageTitle = ({ title, actionLabel, onAction, subtitle }) => {
    return (
        <div className="mb-6 md:flex flex-col sm:flex-row sm:items-center sm:justify-between   md:text-start text-center  hiden ">
            <div>
                <h1 className="text-2xl font-bold text-gray-800">{title}</h1>
                {subtitle && <p className="mt-1 text-sm text-gray-500">{subtitle}</p>}
            </div>

            {actionLabel && onAction && (
                <Button onClick={onAction} className="mt-4 sm:mt-1">
                    <FaPlus className="mr-2 h-4 w-4" />
                    {actionLabel}
                </Button>
            )}
        </div>
    );
};

export default PageTitle;
